import React from "react";
import { Controller } from "react-hook-form";
import NumberFormat from "react-number-format";
import { TextField } from "@material-ui/core";

import { ResponsiveTableCell } from "../../../../components/layout/responsive-table/responsive-table-cell.component";
import { SideBySide } from "../../../../components/side-by-side/side-by-side.component";
import { ProductsTableStatusIndicator } from "../../features/product-status-indicator/components/product-status-indicator/products-table-status-indicator.component";

import { ProductsTablePromoPriceProps } from "./products-table-promo-price.props";

export const ProductsTablePromoPrice = (props: ProductsTablePromoPriceProps) => {
  const inputComponent = (props: any) => {
    const { inputRef, onChange, ...rest } = props;
    return <NumberFormat {...rest} getInputRef={inputRef} isNumericString />;
  };

  const name = `products.${props.index}.futurePrice`;

  return (
    <ResponsiveTableCell className="wide" align="left" size="small">
      <SideBySide>
        <Controller
          control={props.control}
          name={`${name}` as const}
          render={(render) => (
            <TextField
              inputProps={{
                "aria-label": "Promo Price",
              }}
              {...render.field}
              disabled={props.disabled}
              className="form-control underlined"
              onBlur={props.onBlur}
              InputProps={{
                startAdornment: "$\xa0",
                inputComponent,
                style: { fontSize: "13px" },
              }}
            />
          )}
        />
        <ProductsTableStatusIndicator
          field="Price"
          showIf={false}
          status={props.product.futurePriceLastUpdatedSource}
        />
      </SideBySide>
    </ResponsiveTableCell>
  );
};
